export default "__VITE_ASSET__DgHdwE08__"